import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getGLAccountsReq = (action) => {
    const societyId = action?.data?.societyId || '';
    const url = apiEndpoints.GET_GL_ACCOUNTS_API.replace(':societyId', societyId);
    return axiosInstance.get(url);
}
